// extracted by mini-css-extract-plugin
export default {"root":"order-book-warning_root__-gZ1W","info":"order-book-warning_info__zsdUm","action":"order-book-warning_action__xjmDz"};